import type { FC } from 'react'

import styles from '../ehrAppointmentV2.module.scss'
import { ProviderField, type PersonOption } from '../ProviderField'
import { makePrimary, MAX_VISIT_PEOPLE, peopleOf } from './seriesPeople'
import { SERIES_TEXT_V2 } from './seriesText'
import type { SeriesTab } from './useSeriesTab'

export type SeriesBandTab = Pick<SeriesTab, 'seriesPeople' | 'setSeriesPeople' | 'create'>

type Props = {
  tab: SeriesBandTab
  options: PersonOption[]
  disabled: boolean
}

// The Series top list: every visit follows it until a row picks its own people.
export const SeriesProviderBand: FC<Props> = ({ tab, options, disabled }) => {
  const { create, seriesPeople, setSeriesPeople } = tab
  if (!create) return null

  const { ownSteps, bandErrors } = create
  const notes = (
    <>
      {ownSteps.length > 0 && (
        <span className={styles.providerMuted}>
          {SERIES_TEXT_V2.ownProviders(ownSteps.length, ownSteps[0])}
        </span>
      )}
      {bandErrors.map((error, i) => (
        <span key={`${i}-${error}`} className={styles.providerError} role='alert'>
          {error}
        </span>
      ))}
    </>
  )

  return (
    <ProviderField
      multiple
      max={MAX_VISIT_PEOPLE}
      options={options}
      people={seriesPeople?.people ?? []}
      lockedId={null}
      primaryId={seriesPeople?.primaryId ?? null}
      canMakePrimary={(seriesPeople?.people.length ?? 0) > 1}
      disabled={disabled}
      notes={notes}
      onChange={(ids) => setSeriesPeople(peopleOf(ids, seriesPeople?.primaryId))}
      onMakePrimary={(id) => seriesPeople && setSeriesPeople(makePrimary(seriesPeople, id))}
    />
  )
}
